import { HgSupportedLanguage } from '@smg-real-estate/hg-search-libs';

/**
 * Homegate-specific property type URL segments (using singular forms)
 * This mapping defines how property types should appear in Homegate URLs
 * which typically use singular forms vs. IS24's plural forms
 */
export const HG_PROPERTY_SEGMENTS = {
  REAL_ESTATE: {
    [HgSupportedLanguage.DE]: 'immobilien',
    [HgSupportedLanguage.FR]: 'biens-immobiliers',
    [HgSupportedLanguage.IT]: 'immobile',
    [HgSupportedLanguage.EN]: 'real-estate',
  },
  HOUSE: {
    [HgSupportedLanguage.DE]: 'haus',
    [HgSupportedLanguage.FR]: 'maison',
    [HgSupportedLanguage.IT]: 'casa',
    [HgSupportedLanguage.EN]: 'house',
  },
  FLAT: {
    [HgSupportedLanguage.DE]: 'wohnung',
    [HgSupportedLanguage.FR]: 'appartement',
    [HgSupportedLanguage.IT]: 'appartamento',
    [HgSupportedLanguage.EN]: 'apartment',
  },
  COMMERCIAL: {
    [HgSupportedLanguage.DE]: 'gewerbeobjekt',
    [HgSupportedLanguage.FR]: 'commercial',
    [HgSupportedLanguage.IT]: 'imm-commerciale',
    [HgSupportedLanguage.EN]: 'industrial-object',
  },
  PARKING: {
    [HgSupportedLanguage.DE]: 'parkplatz-garage',
    [HgSupportedLanguage.FR]: 'place-de-parc-garage',
    [HgSupportedLanguage.IT]: 'parcheggio-garage',
    [HgSupportedLanguage.EN]: 'parking-place-garage',
  },
  PLOT: {
    [HgSupportedLanguage.DE]: 'bauland',
    [HgSupportedLanguage.FR]: 'terrain',
    [HgSupportedLanguage.IT]: 'terreno',
    [HgSupportedLanguage.EN]: 'plot',
  },
  INVESTMENT: {
    [HgSupportedLanguage.DE]: 'anlegerobjekt',
    [HgSupportedLanguage.FR]: 'investissement',
    [HgSupportedLanguage.IT]: 'investimento',
    [HgSupportedLanguage.EN]: 'investment-property',
  },
  MULTI_FAMILY_HOUSE: {
    [HgSupportedLanguage.DE]: 'mehrfamilienhaus',
    [HgSupportedLanguage.FR]: 'immeuble-locatif',
    [HgSupportedLanguage.IT]: 'casa-plurifamiliare',
    [HgSupportedLanguage.EN]: 'multi-family-house',
  },
  FURNISHED_FLAT: {
    [HgSupportedLanguage.DE]: 'moebliertes-wohnobjekt',
    [HgSupportedLanguage.FR]: 'logement-meuble',
    [HgSupportedLanguage.IT]: 'abitazione-ammobiliata',
    [HgSupportedLanguage.EN]: 'furnished-dwelling',
  },
} as const;
